const sectionPostLine = document.querySelectorAll('section[data-postline]');

sectionPostLine.forEach((item) => {
    var buttonPostText = item.getAttribute('data-postline');

    if(buttonPostText !== ''){
        item.querySelector('.postline').innerHTML = buttonPostText;
    }
});
